import styled from 'styled-components';
import { greenColor } from 'js/config/style';

export default styled.div`
  text-align: right;
  font-weight: 500;
  color: ${greenColor};
`;
